<template>
    <div class="root-canal-specialist-container" id="root-canal-specialist">
        <section class="container">
            <div class="row-custom reverse">
                <div class="team-col">
                    <img src="../assets/images/root-canal-treatment.jpg" id="facings-techniques-img">
                </div>
                <div class="team-col">
                    <h1>Parodontale Zorg</h1>
                    <p>
                        Gezond tandvlees is essentieel voor een gezond gebit. Parodontale zorg richt zich op het voorkomen en behandelen van tandvleesaandoeningen zoals gingivitis en parodontitis. Wij bieden professionele reiniging en behandelingen om ontstekingen tegen te gaan en uw tandvlees gezond te houden. Daarnaast adviseren wij u over de beste mondverzorgingsproducten en technieken om thuis uw tandvlees optimaal te verzorgen.
                    </p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "RootCanalSpecialist",
    mounted() {
        const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden')
      hiddenElements.forEach((el) => observer.observe(el))
    }
}
</script>

<style scoped>
.hidden {
  opacity: 0;
  transform: translateY(100px);
  transition: all 1.5s;
}

.show {
  opacity: 1;
  transform: translateY(0);
}

.team-col {
    flex-basis: 48%;
}

.row-custom {
    margin-bottom: 0px;
}
.team-col img {
    width: 100%;
    max-width: 600px;
}
.team-col h1 {
    padding-top: 0;
}
.team-col p {
    padding: 15px 0 0;
    font-size: 1.4rem;
}

#facings-techniques-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}



@media(max-width: 991px) {
    .row-custom {
        margin-bottom: 20px;
    }
    .row-custom {
        flex-direction: column;
    }
    h1 {
        font-size: 20px;
        text-align: center;
    }

    .team-col img {
        max-width: 100%;
    }

    .team-col p {
        padding: 7px 0px 0px;
    }

    #facings-techniques-img {
        height: 200px;
    }
    .reverse {
        flex-direction: column-reverse;
    }

}
</style>